module.exports = __webpack_public_path__ + "assets/img/default-logo.dc5d99c0.png";